import { createContext, useCallback, useState } from 'react';
import { WarningSeverity } from 'utilities/weather-warnings/warning-severity.js';

type warningSeverityProps = {
  warningSeverity: WarningSeverity;
  setWarningSeverity: (w: WarningSeverity) => void;
};

export const WarningSeverityContext = createContext<warningSeverityProps>({
  warningSeverity: WarningSeverity.None,
  setWarningSeverity: (_: WarningSeverity) => 0,
});

/**
 * Use on Mobile Heading on Secondary Layout to Display Warnings
 * Each mobile header needs its own unique context
 * so that the highest severity is displayed for that particular item
 */
export const WarningMobileSeverityProvider = ({ children }: { children: JSX.Element }) => {
  const [warningSeverity, updateWarningSeverity] = useState<WarningSeverity>(WarningSeverity.None);

  const setWarningSeverity = useCallback(
    (warningSeverity: WarningSeverity) => updateWarningSeverity(warningSeverity),
    [],
  );

  return (
    <WarningSeverityContext.Provider value={{ warningSeverity, setWarningSeverity }}>
      {children}
    </WarningSeverityContext.Provider>
  );
};
